import script from "./TagSpec5030.vue?vue&type=script&setup=true&lang=js"
export * from "./TagSpec5030.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__